module.exports = __webpack_public_path__ + "static/img/banner-191106-winter-sale.ba14188.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banners/banner-191106-winter-sale.png
// module id = R0ZJ
// module chunks = 1